import { Injectable, Inject} from '@angular/core';


export  class ClientEmailDO{
    public id:Number

	public  typeCd:String;

	public  emailId:String;

	public  prefferedFl:Boolean;

	public  getId():Number {
		return this.id;
	}

	public setId(id:Number) {
		this.id = id;
	}

	public  getTypeCd():String {
		return this.typeCd;
	}

	public setTypeCd(typeCd:String) {
		this.typeCd = typeCd;
	}

	public  getEmailId():String {
		return this.emailId;
	}

	public setEmailId( emailId:String) {
		this.emailId = emailId;
	}

	public  getPrefferedFl() :Boolean{
		return this.prefferedFl;
	}

	public setPrefferedFl(prefferedFl:Boolean) {
		this.prefferedFl = prefferedFl;
	}

}